module.exports = __webpack_public_path__ + "static/media/firstCorporateSolutions.3f952e04.jpg";